import { Injectable } from "@angular/core";
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { UserAuthService } from "src/app/services/userauth.service";
import { AdminAuthService } from "src/app/services/adminauth.service";

@Injectable()
export class ViewCanActivate implements CanActivate {
  constructor(
    private userAuthService: UserAuthService,
    private adminAuthService: AdminAuthService,
    private router: Router,
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (next.queryParams["ticket"]) {
      return this.adminAuthService.checkLoginWithTicket(next).pipe(
        map(isLoggedIn => {
          if (!isLoggedIn) {
            this.router.navigate(["viewlogin", next.params.id]);
          }
          return isLoggedIn;
        }),
      );
    }
    // A student's login is the token kept in localStorage
    if (this.userAuthService.checkLogin()) {
      return true;
    }
    // An admin's is the session a ticket opened earlier: its cookie outlives a reload
    return this.adminAuthService.checkLogin().pipe(
      map(isLoggedIn => {
        if (!isLoggedIn) {
          this.router.navigate(["viewlogin", next.params.id]);
        }
        return isLoggedIn;
      }),
    );
  }
}
